import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Field, FieldDescription, FieldGroup, FieldLabel } from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import { loginUser } from "@/lib/auth"

const roleRoutes = {
  affiliate: "/affiliate/dashboard",
  administrator: "/admin/dashboard",
  system_admin: "/system-admin/panel",
}

export function Login({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const successMessage = location.state?.message

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setError("")

    const result = await loginUser({ email, password })

    if (!result.ok) {
      setError(result.error)
      return
    }

    if (result.user) {
      navigate(roleRoutes[result.user.role], { replace: true })
    }
  }

  return (
    <div className={cn("mx-auto flex min-h-screen w-full max-w-md items-center px-4", className)} {...props}>
      <Card>
        <CardHeader>
          <CardTitle>Iniciar sesión</CardTitle>
          <CardDescription>
            Ingresa tu correo electrónico para acceder a tu cuenta
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <FieldGroup>
              <Field>
                <FieldLabel htmlFor="email">Correo Electrónico</FieldLabel>
                <Input 
                  id="email" 
                  type="email" 
                  placeholder="m@ejemplo.com" 
                  required 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
              <Field>
                <FieldLabel htmlFor="password">Contraseña</FieldLabel>
                <Input 
                  id="password" 
                  type="password" 
                  required 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Field>
            </FieldGroup>
            {error && (
              <div className="text-sm font-medium text-destructive">
                {error}
              </div>
            )}
            {successMessage && (
              <div className="text-sm font-medium text-green-600">
                {successMessage}
              </div>
            )}
            <Button type="submit" className="w-full">
              Iniciar Sesión
            </Button>
          </form>
          <div className="mt-4 text-center text-sm">
            ¿No tienes una cuenta?{" "}
            <Button variant="link" className="p-0" onClick={() => navigate("/register")}>
              Regístrate
            </Button>
          </div>
          <div className="mt-8 text-center text-sm text-muted-foreground">
            <p>Usuarios de demostración: admin@inseso.gov y sysadmin@inseso.gov (contraseña: Admin12345!)</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
